module.exports = __webpack_public_path__ + "static/media/img_mobileappperson.a8323331.png";